import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {internalValueRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useInternalValueService} from "../../services/internal-value-service";

const AddEditInternalValueModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [reset, setReset] = useState(0);

  let formSchema = internalValueRequestSchema;

  let internalValueService = useInternalValueService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null) => {
    setLoading(true);
    if (model && model.id){

      let promises = [
        getDetail(model.id)
      ];

      Promise.all(promises).then(([detail=null])=>{
        if (detail){
          setModel(formSchema.cast(detail));
        } else {
          setModel(formSchema.cast());
        }
      }).catch((error)=>{
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať detail.");
      }).finally(()=>{
        setLoading(false);
      });

    } else {
      setModel(formSchema.cast());
      setLoading(false);
    }
    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return internalValueService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    const reqValues = values;

    internalValueService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue}) => (

          <Modal size={model && model.id ? 'lg' : 'sm' } show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nová interná hodnota' : 'Úprava internej hodnoty' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form className="row">

                  <FormGroup
                      name="value_at"
                      type="date"
                      placeholder="Dátum"
                      label="Dátum"
                      className="col-md-6"
                      touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="value"
                    placeholder="Hodnota"
                    label="Hodnota"
                    className="col-md-6"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditInternalValueModal;
